import axios from "axios";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../const/api";
import {
  setShowUserDepositModal
} from "../features/modals/modalsSlice";
import {
  selectCurrency,
  selectId,
  selectToken,
  selectUser,
  setNewToken,
} from "../features/user/userSlice";
import {
  errorNotification,
  successNotification,
  warningNotification,
} from "../utils/toastNotifications";
import { validateWithdrawPay4Fun } from "../utils/validations";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../const/colors";
import { permitirGuardarFavorito } from "../utils/tools";

const initialForm = {};
const initialFormPay4Fun = {
  monto2: "",
  nombre: "",
  numeroCuenta: "",
  tipoCuenta: "",
  nombreBanco: "",
  cedula: "",
  email: "",
  pixKeyType: "",
  codigoArea: "",
  telefono: "",
  sucursalBanco: ""
};

const initialFormAstroPay = {
  monto1: "",
  numeroTelefono:""
};

const initialFormRetail = {
  monto2: '',
  nombre: '',
  apellido: '',
  numeroCuenta: '',
  tipoCuenta: '',
  nombreBanco: '',
  cedula: '',
  email: ''
}

const initialFormTuPay= {
  numeroCuenta: '',
  tipoCuenta: '',
  cedula: '',
  documentType: '',
  monto: ''
}

const initialFormMonnet= {
  bank: '',
  bank_account: '',
  account_type: '',
  monto: '',
  tipo: '',
  cedula: '',
  letra:''
}
const initialFormMonnetPeru= {
  bank: '',
  bank_account: '',
  account_type: '',
  monto: '',
  tipo: '',
  cedula: ''
}

const initialFormPagoFacil= {
  financial_institution: '',
  bank_account: '',
  document_type_code: '',
  currency_code: '',
  monto: ''
}

const initialFormCoinspaidRetiro= {
  monto: '',
  wallet_address: '',
  cryptocurrency: '',
  memo_tag:''
}

const initialFormBinanceUSD= {
  monto: '',
  email:'',
}
const initialFormPix= {
  monto: '',
  email:'',
  telefono:'',
  cpf:'',
  metodo:'',

}
const initialFormSpei= {
  monto: '',
  receiver_clabe:'',
}

const initialFormAlps= {
  monto: '',
  document_type:'',
  document:'',
  bank:'',
  bank_account_type:'',
  bank_account:'',
}

const initialFormKushki= {
  monto: '',
  bank_id:'',
  tipo_cuenta:'',
  account_number:'',
  tipodocumento:'',
  document:'',
}

const initialFormMibanco = {
  monto1: '',
  tipodocumento: '',
  cedula: '',
  banco: '',
  telefono_destino: '',
}

const initialFormTransPYG= {
  monto: '',
  bank_code:'',
  account_number:'',
  document_type:'',
  document_number:'',

}

const initialFormBDV = {
  monto1: '',
  document_type: '',
  cedula: '',
  bank_code: '',
  destination_phone: '',
}


export const useWithdraw = () => {
  const user = useSelector(selectUser);
  const id_uo = useSelector(selectId);
  const moneda = useSelector(selectCurrency);
  const token = useSelector(selectToken);

  const [form, setForm] = useState(initialForm);
  const [formPay4Fun, setFormPay4Fun] = useState(initialFormPay4Fun);
  const [formAstroPay, setFormAstroPay] = useState(initialFormAstroPay);
  const [formPayRetailer, setFormPayRetailer] = useState(initialFormRetail);
  const [formTuPay, setFormTuPay] = useState(initialFormTuPay);
  const [formMonnet, setFormMonnet] = useState(initialFormMonnet);
  const [formMonnetperu, setFormMonnetperu] = useState(initialFormMonnetPeru);
  const [formPagoFacil, setFormPagoFacil] = useState(initialFormPagoFacil);
  const [formCoinspaidRetiro, setformCoinspaidRetiro] = useState(initialFormCoinspaidRetiro);
  const [formBinanceUSD, setformBinanceUSD] = useState(initialFormBinanceUSD);
  const [formPix, setformPix] = useState(initialFormPix);
  const [formSpei, setformSpei] = useState(initialFormSpei);
  const [formAlps, setformAlps] = useState(initialFormAlps);
  const [formKushkiRetiro, setformKushkiRetiro] = useState(initialFormKushki);
  const [formMibanco, setformMibanco] = useState(initialFormMibanco);
  const [formTransPYG, setformTransPYG] = useState(initialFormTransPYG);
  const [formBDV, setformBDV] = useState(initialFormBDV);

  const [bancoTipo, setBancoTipo] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleClose = () => {
    setForm({});
    dispatch(setShowUserDepositModal({open: false, type: false}));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleChangePay4Fun = (e) => {
    setFormPay4Fun({ ...formPay4Fun, [e.target.name]: e.target.value });
  };

  const handleChangeAstroPay = (e) => {
    setFormAstroPay({ ...formAstroPay, [e.target.name]: e.target.value });
  };

  const handleChangePayRetailer = (e) => {
    setFormPayRetailer({ ...formPayRetailer, [e.target.name]: e.target.value });
  };

  const handleChangeTuPay = (e) => {
    setFormTuPay({ ...formTuPay, [e.target.name]: e.target.value });
  };
  const handleChangeMonnet = (e) => {
    setFormMonnet({ ...formMonnet, [e.target.name]: e.target.value });
  };
   const handleChangeMonnetperu = (e) => {
    setFormMonnetperu({ ...formMonnetperu, [e.target.name]: e.target.value });
  };
  const handleChangePagoFacil = (e) => {
    setFormPagoFacil({ ...formPagoFacil, [e.target.name]: e.target.value });
  };

  const handleChangeCoinspaidRetiro = (e) => {
    setformCoinspaidRetiro({ ...formCoinspaidRetiro, [e.target.name]: e.target.value });
  };

  const handleChangeBinanceUSD = (e) => {
    setformBinanceUSD({ ...formBinanceUSD, [e.target.name]: e.target.value });
  };

  const handleChangePix = (e) => {
    setformPix({ ...formPix, [e.target.name]: e.target.value });
  };

  const handleChangeSpei = (e) => {
    setformSpei({ ...formSpei, [e.target.name]: e.target.value });
  };

  const handleChangeAlps = (e) => {
    setformAlps({ ...formAlps, [e.target.name]: e.target.value });
  };

  const handleChangeKushkiRetiro = (e) => {
    setformKushkiRetiro({ ...formKushkiRetiro, [e.target.name]: e.target.value });
  };

  const handleChangeMibanco = (e) => {
    setformMibanco({ ...formMibanco, [e.target.name]: e.target.value });
  };

  const handleChangeTransPYG = (e) => {
    setformTransPYG({ ...formTransPYG, [e.target.name]: e.target.value });
  };

   const handleChangeBDV = (e) => {
    setformBDV({ ...formBDV, [e.target.name]: e.target.value });
  };


  const handleBanco = (e) => {
    setBancoTipo(e.target.value);
  };

  const solicitarRetiro = async (e) => {
    e.preventDefault()

    if (bancoTipo.split("-")[0] === "transferencia") {
      // Validar que bank_account contenga solo números
      if (!/^\d+$/.test(form.numeroCuenta)) {
        return errorNotification(
          "Cuenta inválida: El número de cuenta solo debe contener números",
          "top-center"
        );
      }
    }

    if (moneda ==='Bs.S' && form.numeroCuenta.length !== 20) {
      // Validar que bank_account contenga solo números
        return errorNotification(
          "Cuenta inválida: El número de cuenta debe contener 20 dígitos",
          "top-center"
        );
    }
    if (!bancoTipo)
      return errorNotification("Seleccione el tipo de pago", "top-center");
    for (let x in form) {
      if (form[x] === "")
        return errorNotification(
          "Por favor complete todos los campos",
          "top-center"
        );
    }

    const body = {
      ...form,
      id_uo,
      moneda,
      token,
      usuario: user,
      tipoOperacion: bancoTipo.split("-")[0],
      monto2: parseFloat(form.monto2.replaceAll(".", "").replace(",", ".")),
    };

    if (moneda === "Sol" && bancoTipo.split("-")[0] === "yape") {
      if (body.monto2 > 250) {
        return errorNotification(
          "Disculpe, el monto máximo a retirar por Yape es de S/.250. Si desea retirar un monto mayor por favor seleccione la opción de BCP.",
          "top-center"
        );
      }
    }

    if (bancoTipo.split("-")[0] === "zelle") {
      if (body.monto2 < 100) {
        return errorNotification(
          "Disculpe: Monto mínimo de retiro por Zelle debe ser mayor o igual a 100 USD",
          "top-center"
        );
      }
    }

    setLoading(true);

    const res = await axios.post(API_URL + "solicitarRetiro", body);
    if (res.data.status === 1) {
      dispatch(setNewToken(res.data.token));
      if (res.data.response.includes("registrados")) {
        const proceed = permitirGuardarFavorito(moneda, bancoTipo.split("-")[0])
        const existeFav = await axios.post(API_URL + "getFavoritoRetiroById", body);
        
        if(!existeFav.data.response && proceed) {
          Swal.fire({
            html:
              `<h3>Su solicitud de retiro ha sido enviada satisfactoriamente.</h3> ` +
              `<p class="register-p">¿Desea guardar este método de retiro como favorito?</p>` +
              `<b></b>`,
            icon: "success",
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cerrar',
            allowOutsideClick: false,
            background: SECONDARY,
            color: "#fff",
            confirmButtonColor: PRIMARY,
          }).then(async(result) => {
            if (result.isConfirmed) {
              const guardar =  await axios.post(API_URL + "guardarFavoritoRetiro", body);
              if(guardar.data.response!=='existe') {
                if(guardar.data.response) {
                  successNotification("Se ha guardado el método de retiro como favorito.")
                } else {
                  errorNotification("Ocurrió un error al intentar guardar el método de retiro.")
                }
              } else {
                errorNotification("Ya existe el método de retiro en favoritos.")
              }
              handleClose();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              handleClose();
            }
          });
        } else {
          let verificando = {
            title: `Enviada satisfactoriamente.`,
            text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
            allowOutsideClick: true,
            icon: "success",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }
      } else {
        if(res.data.response.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.response}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.response.includes("en espera")) {
            let verificando = {
              title: `En Espera.`,
              text: `${res.data.response}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{

            if(res.data.response.includes("minimo")) {
              let verificando = {
                title: `Monto minimo.`,
                text: `${res.data.response}`,
                allowOutsideClick: true,
                icon: "info",
                background: SECONDARY,
                color: "#fff",
                showConfirmButton: true,
                confirmButtonColor: PRIMARY,
                confirmButtonText: "Aceptar",
              };
              Swal.fire(verificando);
              handleClose();
            }else{

              if(res.data.response.includes("máximo")) {
                let verificando = {
                  title: `Monto máximo.`,
                  text: `${res.data.response}`,
                  allowOutsideClick: true,
                  icon: "info",
                  background: SECONDARY,
                  color: "#fff",
                  showConfirmButton: true,
                  confirmButtonColor: PRIMARY,
                  confirmButtonText: "Aceptar",
                };
                Swal.fire(verificando);
                handleClose();
              }else{

                if(res.data.response.includes("este retiro")) {
                  let verificando = {
                    title: `Retiro solicitado anteriormente.`,
                    text: `${res.data.response}`,
                    allowOutsideClick: true,
                    icon: "info",
                    background: SECONDARY,
                    color: "#fff",
                    showConfirmButton: true,
                    confirmButtonColor: PRIMARY,
                    confirmButtonText: "Aceptar",
                  };
                  Swal.fire(verificando);
                  handleClose();
                }else{

                  warningNotification(res.data.response);
                }
              }
            }
          }
        }
      }
    } else {
      dispatch(setNewToken(res.data.token));
      //errorNotification("Ha ocurrido un error, por favor intente de nuevo");
    }
    setLoading(false);
  };

  const solicitarRetiroRetailer = async (e) => {
    e.preventDefault();
    let validated = validateWithdrawPay4Fun(formPay4Fun);
    if (validated === "ok") {
      let [nombreB, codigoB] = formPay4Fun.nombreBanco
        ? formPay4Fun.nombreBanco.split("_")
        : ["", ""];
      const body = {
        ...formPay4Fun,
        nombreBanco: nombreB,
        codigoBanco: codigoB,
        id_uo,
        token,
        usuario: user,
        monto: parseFloat(
          formPay4Fun.monto2.replaceAll(".", "").replace(",", ".")
        ).toFixed(2),
      };

      if (formPay4Fun.pixKeyType !== "DadosBancarios") {
        delete body.numeroCuenta;
        delete body.tipoCuenta;
        delete body.nombreBanco;
        delete body.sucursalBanco;
      }

      if (formPay4Fun.pixKeyType === "DadosBancarios") {
       // Validar que bank_account contenga solo números
        if (!/^\d+$/.test(formPay4Fun.numeroCuenta)) {
          return errorNotification(
            "Cuenta inválida: El número de cuenta solo debe contener números",
            "top-center"
          );
        }
      }

      if (formPay4Fun.pixKeyType !== "Telefone") {
        delete body.codigoArea;
        delete body.telefono;
      }
      delete body.monto2;

      setLoading(true);
      const res = await axios.post(API_URL + "generarSolicitudRetiroP4F", body);
      if (res.data.error === 0) {
        successNotification(
          "¡Su solicitud de retiro ha sido enviada satisfactoriamente",
          "top-center"
        );
        handleClose();
      } else {
        //errorNotification("Ha ocurrido un error");
        if (res.data.error) {
          errorNotification(res.data.error, "top-center");
        } else {
          errorNotification("Ha ocurrido un error", "top-center");
        }
      }
    } else {
      errorNotification(validated, "top-center");
    }
    setLoading(false);
  };


  const solicitarRetiroAstroPay = async (e) => {
    e.preventDefault();

    if (!formAstroPay.monto1 || !formAstroPay.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    if (!formAstroPay.numeroTelefono || !formAstroPay.numeroTelefono.trim())
    return errorNotification(
      "Por favor ingrese el número de teléfono",
      "top-center"
    );

    if (
      !formAstroPay.numeroTelefono.startsWith("+593") &&
      !formAstroPay.numeroTelefono.startsWith("+56") &&
      !formAstroPay.numeroTelefono.startsWith("+54") &&
      !formAstroPay.numeroTelefono.startsWith("+57")
    ) {
      let verificando = {
        title: `Número inválido`,
        text: `Por favor agregue el código telefónico de su país incluyendo el signo +`,
        allowOutsideClick: false,
        icon: "info",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };

      Swal.fire(verificando);
      return;
    }

    let codearea = null;
    let telefono = null;

    if (formAstroPay.numeroTelefono.startsWith("+593")) {
        codearea = "+593";
        telefono = formAstroPay.numeroTelefono.slice(4);
    } else if (formAstroPay.numeroTelefono.startsWith("+56")) {
        codearea = "+56";
        telefono = formAstroPay.numeroTelefono.slice(3);
    } else if (formAstroPay.numeroTelefono.startsWith("+54")) {
        codearea = "+54";
        telefono = formAstroPay.numeroTelefono.slice(3);
    } else if (formAstroPay.numeroTelefono.startsWith("+57")) {
        codearea = "+57";
        telefono = formAstroPay.numeroTelefono.slice(3);
    }

    let monto = parseFloat(
      formAstroPay.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);

    if (monto <= 0)
      return errorNotification(
        "El monto a depositar debe ser mayor a 0",
        "top-center"
      );

    const body = {
      monto,
      id_uo,
      moneda,
      token,
      usuario: user,
      codearea,
      telefono
    };

    setLoading(true);
    const res = await axios.post(
      API_URL + "generarSolicitudRetiroAstroPay",
      body
    );

    if (res.data.code === 200) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.message) {
        if(res.data.message.includes("es mayor")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };


  const solicitarRetiroTuPay = async (e) => {
    e.preventDefault();

    if (!formTuPay.cedula || !formTuPay.cedula.trim())
      return errorNotification(
        'Por favor ingrese su documento de identidad',
        "top-center"
      );

    if (!formTuPay.documentType || !formTuPay.documentType.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );


    const cedula = formTuPay.cedula.trim();
    const documentType = formTuPay.documentType.trim();

    if (documentType === "PASS" && !/^\d{12}$/.test(cedula)) {
      return errorNotification(
        "PASS incorrecto, debe contener 12 dígitos",
        "top-center"
      );
    }

    if (documentType === "RUC" && !/^\d{11}$/.test(cedula)) {
      return errorNotification(
        "RUC incorrecto, debe contener 11 dígitos",
        "top-center"
      );
    }

    if (documentType === "CE" && !/^\d{9}$/.test(cedula)) {
      return errorNotification(
        "CE incorrecto, debe contener 9 dígitos",
        "top-center"
      );
    }

    if (documentType === "DNI" && !/^\d{8}$/.test(cedula)) {
      return errorNotification(
        "DNI incorrecto, debe contener 8 digitos",
        "top-center"
      );
    }

    if (!formTuPay.numeroCuenta || !formTuPay.numeroCuenta.trim())
    return errorNotification(
      "Por favor ingrese su numero de cuenta",
      "top-center"
    );

    // Validar que bank_account contenga solo números
    if (!/^\d+$/.test(formTuPay.numeroCuenta)) {
      return errorNotification(
          "Cuenta inválida: El número de cuenta solo debe contener números",
          "top-center"
      );
    }

    if (!formTuPay.tipoCuenta || !formTuPay.tipoCuenta.trim())
    return errorNotification(
      "Por favor selecciones el tipo de cuenta",
      "top-center"
    );

    if (!formTuPay.monto || !formTuPay.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formTuPay.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formTuPay,
      monto,
      id_uo,
      moneda,
      usuario: user,
      token
    };

    setLoading(true);
    const res = await axios.post(
      API_URL + "generarSolicitudRetiroTuPay",
      body
    );
    console.log(res.data);

    if (res.data.error === 0) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.error) {
        if(res.data.error.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.error.includes("en espera")) {
            let verificando = {
              title: `En Espera.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroMonnet = async (e) => {
    e.preventDefault();
    
    if (!formMonnet.bank || !formMonnet.bank.trim())
    return errorNotification(
      "Por favor seleccione el banco",
      "top-center"
    );
    if (!formMonnet.bank_account || !formMonnet.bank_account.trim())
    return errorNotification(
      "Por favor ingrese su numero de cuenta",
      "top-center"
    );
  // Validar que bank_account contenga solo números
    if (!/^\d+$/.test(formMonnet.bank_account)) {
      return errorNotification(
          "Cuenta inválida: El número de cuenta solo debe contener números",
          "top-center"
      );
    }
    if (!formMonnet.account_type || !formMonnet.account_type.trim())
    return errorNotification(
      "Por favor selecciones el tipo de cuenta",
      "top-center"
    );

   if (!formMonnet.tipo || !formMonnet.tipo.trim())
    return errorNotification(
      "Por favor selecciones el tipo de documento",
      "top-center"
    );

   if (!formMonnet.cedula || !formMonnet.cedula.trim())
    return errorNotification(
      "Por favor ingrese su documento de identidad",
      "top-center"
    );

    if (moneda === 'CLP') {
      // Validar el tipo de documento y la longitud de cedula
      const cedulaValue = formMonnet.cedula;
      const cedulaLength = cedulaValue.length;
      const letravalue = formMonnet.letra;
      const letraLength = letravalue.length;
      const account = formMonnet.bank_account;
      const numberAccount = account.length;
      const idRegex = /^(\d{7}|\d{6}-\d|\d{8}-\d|\d{9})$/;
      const runRegex = /^(\d{6}[a-zA-Z0-9]|\d{8}[a-zA-Z0-9])$/;
      const bankCode = formMonnet.bank.split(' - ')[0]; 
      const concatenatedLength = cedulaLength + letraLength;
      const concatenatedValue = cedulaValue + letravalue;
      const lastCharacter = concatenatedValue.slice(-1);
      const firstEightDigits = concatenatedValue.slice(0, 8);

      if (formMonnet.tipo === '1' || formMonnet.tipo === '2') {
       if (!formMonnet.letra || !formMonnet.letra.trim())
        return errorNotification(
          "Por favor ingrese letra o número de su documento de identidad",
          "top-center"
        );
      }

      if (bankCode === '012') {
        const first8CedulaDigits = cedulaValue.replace(/[^0-9]/g, '').substring(0, 8);
        const first8AccountDigits = account.substring(0, 8);

        if (first8CedulaDigits !== first8AccountDigits) {
          return errorNotification(
            "El número de cuenta debe contener los primeros 8 dígitos del número de documento de identidad",
            "top-center"
          );
        }
      }

      if (numberAccount < 6 || numberAccount > 20) {
        return errorNotification(
          "El número de cuenta debe contener entre 6 y 20 digitos"
        );
      }

      switch (formMonnet.tipo) {
        case "1":
          if (concatenatedLength !== 9) {
            return errorNotification(
              "El RUT debe contener 9 dígitos",
              "top-center"
            );
          }
          if (!/[0-9a-zA-Z]/.test(lastCharacter)) {
            return errorNotification(
              "El RUT debe terminar con un número o una letra",
              "top-center"
            );
          }

          if (cedulaLength < 8) {
            return errorNotification(
              "Error, debe colocar 8 números antes del " - " ",
              "top-center"
            );
          }

          if (!/^[0-9]+$/.test(firstEightDigits)) {
            return errorNotification(
              "Los primeros 8 digitos del RUT deben ser números",
              "top-center"
            );
          }
        break;
        case "2":
          if (concatenatedLength !== 9) {
            return errorNotification(
              "El RUN debe contener 9 dígitos",
              "top-center"
            );
          }
          if (!/[0-9a-zA-Z]/.test(lastCharacter)) {
            return errorNotification(
              "El RUN debe terminar con un número o una letra",
              "top-center"
            );
          }

          if (cedulaLength < 8) {
            return errorNotification(
              "Error, debe colocar 8 números antes del " - " ",
              "top-center"
            );
          }

          if (!/^[0-9]+$/.test(firstEightDigits)) {
            return errorNotification(
              "Los primeros 8 digitos del RUN deben ser números",
              "top-center"
            );
          }
        break;
        case "3":
          if (cedulaLength < 9) {
            return errorNotification(
              "El PAS debe contener 9 o más dígitos",
              "top-center"
            );
          }
        break;
        case "4":
          if (cedulaLength < 9) {
            return errorNotification(
              "El CE debe contener 9 o más dígitos",
              "top-center"
            );
          }
         break;
      }
    }else{

      if (moneda === '$') {
        const cedulaLength = formMonnet.cedula.length;
        const account = formMonnet.bank_account;
        const numberAccount = account.length;
        const bankCode = formMonnet.bank.split(' - ')[0]; 

        if (numberAccount < 7 || numberAccount > 20) {
          return errorNotification(
            "El número de cuenta debe contener entre 7 y 20 digitos"
          );
        }

        if (bankCode === '010' ) {
          if (numberAccount !== 10) {
            return errorNotification(
              "El número de cuenta debe contener 10 dígitos para Banco Pichincha C.A.",
              "top-center"
            );
          }
        }

        if (bankCode === '017' ) {
          if (numberAccount !== 10) {
            return errorNotification(
              "El número de cuenta debe contener 10 dígitos para Banco de Guayaquil S.A",
              "top-center"
            );
          }
        }

        if (formMonnet.account_type === '4') {
          if (formMonnet.tipo !== '1' && formMonnet.tipo !== "2" ) {
            return errorNotification(
              "El tipo de documento debe ser CEDULA o PAS para tipo de cuenta: EFE",
              "top-center"
            );
          }
        }

        if (bankCode !== '010') {
          if (formMonnet.account_type === '4') {
            return errorNotification(
              "Debe ser Banco Pichincha C.A. para tipo de cuenta: EFE",
              "top-center"
            );
          }
        }

        if (formMonnet.monto > 2000) {
          if (formMonnet.account_type === '4') {
            return errorNotification(
              "El monto no debe ser mayor a $2000 para tipo de cuenta: EFE",
              "top-center"
            );  
          }
        }


        switch (formMonnet.tipo) {
          case "1":
            if (cedulaLength !== 10) {
              return errorNotification(
                  "La CEDULA debe contener 10 dígitos",
                  "top-center"
              );
            }
          break;
          case "2":
            if (cedulaLength !== 13) {
              return errorNotification(
                  "El PAS debe contener 13 dígitos",
                  "top-center"
              );
            }
            if (!formMonnet.cedula.endsWith('001')) {
              return errorNotification(
                "El PAS debe terminar en 001",
                "top-center"
              );
            }
          break;
          case "3":
            if (cedulaLength !== 13) {
              return errorNotification(
                  "El RUC debe contener 13 dígitos",
                  "top-center"
              );
            }
          break;
        }
      }else{
        if (moneda === 'GTQ') {
          if (formMonnet.tipo === '1' && formMonnet.cedula.length !== 13)
          return errorNotification(
            "DPI debe contener 13 dígitos",
            "top-center"
          );

          if (formMonnet.tipo === '2' && !(formMonnet.cedula.length === 13 || formMonnet.cedula.length === 10))
          return errorNotification(
            "NIT debe contener 13 dígitos para persona natural o 10 digitos para persona jurídica",
            "top-center"
          );
        }
      }
    }

    if (!formMonnet.monto || !formMonnet.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formMonnet.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    if (moneda === 'CLP' && formMonnet.letra !== '') {
      formMonnet.cedula = formMonnet.cedula + '.' + formMonnet.letra;
    }
    const body = {
      ...formMonnet,
      amount: monto,
      id_uo,
      token
    };

    setLoading(true);
    const res = await axios.post(API_URL + "createWithdrawalTransaction", body);

    if (res.data.code === 200) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.message) {
        if(res.data.message.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.message.includes("en espera")) {
            let verificando = {
              title: `En Espera.`,
              text: `${res.data.message}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.message, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroMonnetperu = async (e) => {
    e.preventDefault();
    
    if (!formMonnetperu.bank || !formMonnetperu.bank.trim())
    return errorNotification(
      "Por favor seleccione el banco",
      "top-center"
    );
    if (!formMonnetperu.bank_account || !formMonnetperu.bank_account.trim())
    return errorNotification(
      "Por favor ingrese su numero de cuenta",
      "top-center"
    );

  // Validar que bank_account contenga solo números
    if (!/^\d+$/.test(formMonnetperu.bank_account)) {
      return errorNotification(
          "Cuenta inválida: El número de cuenta solo debe contener números",
          "top-center"
      );
    }

    // Validar que bank_account tenga 20 dígitos
    if (formMonnetperu.bank_account.length !== 20) {
      return errorNotification(
          "Cuenta inválida: El número de cuenta debe tener 20 dígitos",
          "top-center"
      );
    }


   if (!formMonnetperu.tipo || !formMonnetperu.tipo.trim())
    return errorNotification(
      "Por favor selecciones el tipo de documento",
      "top-center"
    );

   if (!formMonnetperu.cedula || !formMonnetperu.cedula.trim())
    return errorNotification(
      "Por favor ingrese su documento de identidad",
      "top-center"
    );

   // Validar el tipo de documento y la longitud de cedula
    const cedulaLength = formMonnetperu.cedula.length;
    switch (formMonnetperu.tipo) {
      case "1":
      if (cedulaLength !== 8) {
        return errorNotification(
            "El DNI debe contener 8 dígitos",
            "top-center"
        );
      }
      break;
      case "2":
        if (cedulaLength < 7 || cedulaLength > 12) {
          return errorNotification(
              "El PAS debe contener entre 7 y 12 dígitos",
              "top-center"
          );
        }
      break;
      case "3":
        if (cedulaLength < 8 || cedulaLength > 12) {
          return errorNotification(
              "El CE debe contener entre 8 y 12 dígitos",
              "top-center"
          );
        }
      break;
      case "4":
        if (cedulaLength !== 11) {
          return errorNotification(
              "El RUC debe contener 11 dígitos",
              "top-center"
          );
        }
      break;

    }

    if (!formMonnetperu.monto || !formMonnetperu.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formMonnetperu.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formMonnetperu,
      amount: monto,
      id_uo,
      token,
      account_type: '2'
    };

    setLoading(true);
    const res = await axios.post(API_URL + "createWithdrawalTransaction", body);
    console.log(res);

    if (res.data.code === 200) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.message) {
        if(res.data.message.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.message.includes("en espera")) {
            let verificando = {
              title: `En Espera.`,
              text: `${res.data.message}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.message, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };


  const solicitarRetiroPagoFacil = async (e) => {
    e.preventDefault();

    if (!formPagoFacil.financial_institution || !formPagoFacil.financial_institution.trim())
    return errorNotification(
      "Por favor seleccione el banco",
      "top-center"
    );

    if (!formPagoFacil.bank_account || !formPagoFacil.bank_account.trim())
    return errorNotification(
      "Por favor ingrese su numero de cuenta",
      "top-center"
    );

    // Validar que bank_account contenga solo números
    if (!/^\d+$/.test(formPagoFacil.bank_account)) {
      return errorNotification(
          "Cuenta inválida: El número de cuenta solo debe contener números",
          "top-center"
      );
    }

    if (!formPagoFacil.document_type_code || !formPagoFacil.document_type_code.trim())
    return errorNotification(
      "Por favor selecciones el tipo de documento",
      "top-center"
    );
    if (!formPagoFacil.currency_code || !formPagoFacil.currency_code.trim())
    return errorNotification(
      "Por favor selecciones el tipo de moneda",
      "top-center"
    );

    if (!formPagoFacil.monto || !formPagoFacil.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formPagoFacil.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formPagoFacil,
      amount: monto,
      id_uo,
      token
    };

    setLoading(true);
    const res = await axios.post(API_URL + "createWithdrawalTransactionPagoFacil", body);

    if (res.data.code === 200) {

      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.message) {
        if(res.data.message.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.message.includes("en espera")) {
            let verificando = {
              title: `En Espera.`,
              text: `${res.data.message}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.message, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const clearForm = () => {
    setForm(initialForm)
  }

  const solicitarRetiroPayRetailer = async (e) => {
    e.preventDefault();
    // Validar que bank_account contenga solo números
    if (!/^\d+$/.test(formPayRetailer.numeroCuenta)) {
      return errorNotification(
          "Cuenta inválida: El número de cuenta solo debe contener números",
          "top-center"
      );
    }
    for(let x in formPayRetailer) {
      if(formPayRetailer[x]==='') return errorNotification('Por favor complete todos los campos')
    }
    if((moneda!=='BRL'&&moneda!=='CLP')&&(formPayRetailer.numeroAgencia===''||!formPayRetailer.numeroAgencia)) return errorNotification('Por favor complete todos los campos');
    if((moneda==='$'||moneda==='Sol')&&(!formPayRetailer.direccion||formPayRetailer.direccion==='')) return errorNotification('Por favor complete todos los campos');
    if((moneda==='$'||moneda==='Sol')&&(!formPayRetailer.ciudad||formPayRetailer.ciudad==='')) return errorNotification('Por favor complete todos los campos');
    if((moneda==='Sol'||moneda==='$')&&(!formPayRetailer.telefono||formPayRetailer.telefono==='')) return errorNotification('Por favor complete todos los campos');
    let [nombreB, codigoB] = formPayRetailer.nombreBanco.split('_');
    const body = {
      ...formPayRetailer,
      nombreBanco: nombreB,
      codigoBanco: codigoB,
      id_uo,
      moneda,
      token,
      usuario: user,
      monto: parseFloat(formPayRetailer.monto2.replaceAll('.', '').replace(',', '.')).toFixed(2)
    }
    delete body.monto2;
    console.clear();
    console.log(body);

    setLoading(true);
    const res = await axios.post(API_URL+'solicitarRetiroRetail', body);
    if(res.data.status===1) {
      if(res.data.success.includes('registrados')) {
        successNotification('¡Su solicitud de retiro ha sido enviada satisfactoriamente');
        handleClose();
      } else {
        warningNotification(res.data.response);
      }
    } else {
      //errorNotification("Ha ocurrido un error");
      if(res.data.error) {
        if(typeof res.data.error === 'string') {
          errorNotification(res.data.error)
        } else {
          if(res.data.error.errors) {
            let err = res.data.error.errors;
            Array.from(err).forEach((el)=>errorNotification(el.errorMessage));
          } else {
            errorNotification("ERROR "+res.data.error.status+": "+res.data.error.title)
          }
        }
      }
    }
    setLoading(false);
  }

  const solicitarRetiroCoinspaid = async (e) => {
    e.preventDefault();

    if (!formCoinspaidRetiro.wallet_address|| !formCoinspaidRetiro.wallet_address.trim())
      return errorNotification(
        'Por favor ingrese la direccion de billetera',
        "top-center"
      );

    if (!formCoinspaidRetiro.cryptocurrency || !formCoinspaidRetiro.cryptocurrency.trim())
    return errorNotification(
      "Por favor seleccione Criptomoneda",
      "top-center"
    );
     
    if (formCoinspaidRetiro.cryptocurrency === 'XRP' || formCoinspaidRetiro.cryptocurrency === 'BNB-BSC' 
      || formCoinspaidRetiro.cryptocurrency === 'BTS' || formCoinspaidRetiro.cryptocurrency === 'EOS') {

      if (!formCoinspaidRetiro.memo_tag || !formCoinspaidRetiro.memo_tag.trim()) {
          return errorNotification(
          "Por favor Ingrese Memo",
          "top-center"
        );
      }
    }


    if (!formCoinspaidRetiro.monto || !formCoinspaidRetiro.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto",
      "top-center"
    );
    let amount = parseFloat(
      formCoinspaidRetiro.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (amount <= 0)
      return errorNotification(
        "Por favor ingrese el monto",
        "top-center"
      );

    const body = {
      ...formCoinspaidRetiro,
      amount,
      id_uo,
      token
    };

    setLoading(true);
    const res = await axios.post(
      API_URL + "createWithdrawalTransactionCoinspaid",
      body
    );

    if (res.data.code === 200) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `${res.data.message}`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.message) {
          if(res.data.message.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.message.includes("pendiente")) {
            let verificando = {
              title: `Retiro Pendiente.`,
              text: `${res.data.message}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.message, "top-center");
          }
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroBinanceUSD = async (e) => {
    e.preventDefault();

    if (!formBinanceUSD.email || !formBinanceUSD.email.trim())
    return errorNotification(
      "Por favor ingrese el email",
      "top-center"
    );

    if (!formBinanceUSD.monto || !formBinanceUSD.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formBinanceUSD.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formBinanceUSD,
      monto,
      id_uo,
      token
    };

    setLoading(true);
    const res = await axios.post(
      API_URL + "generarSolicitudRetiroBinancePayUSDOut",
      body
    );
    console.log(res);

    if (res.data.error === 0) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.error) {
        if(res.data.error.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.error.includes("en espera")) {
            let verificando = {
              title: `En espera.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroPix = async (e) => {
    e.preventDefault();

    if (formPix.metodo === "email" && formPix.email ==='')
    return errorNotification(
      "Por favor ingrese el email",
      "top-center"
    );

    if (formPix.metodo === "telefono" && formPix.telefono ==='')
    return errorNotification(
        "Por favor ingrese el telefono",
        "top-center"
    );

    if (formPix.metodo === "telefono" && formPix.telefono !=='' && !formPix.telefono.startsWith("+55"))
    return errorNotification(
      "El teléfono debe iniciar con +55",
      "top-center"
    );

    if (formPix.metodo === "documento" && formPix.cpf ==='')
    return errorNotification(
        "Por favor ingrese el CPF",
        "top-center"
    );

    if (formPix.metodo === "documento" && formPix.cpf !==''){

      // Elimina espacios, caracteres especiales, guiones y puntos
      const sanitizeCpf = (cpf) => {
          return cpf.replace(/[^\d]/g, ''); // Elimina todo excepto dígitos
      };

      // Actualizamos formPix.cpf con la versión limpia
      formPix.cpf = sanitizeCpf(formPix.cpf);

      // Función para validar el formato y los dígitos verificadores del CPF
      const isValidCpf = (cpf) => {
        if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
            return false;
        }

        let sum = 0;
        // Cálculo del primer dígito verificador
        for (let i = 0; i < 9; i++) {
            sum += parseInt(cpf.charAt(i)) * (10 - i);
        }
        let rest = sum % 11;
        let digit1 = (rest < 2) ? 0 : (11 - rest);

        sum = 0;
        // Cálculo del segundo dígito verificador
        for (let i = 0; i < 10; i++) {
            sum += parseInt(cpf.charAt(i)) * (11 - i);
        }
        rest = sum % 11;
        let digit2 = (rest < 2) ? 0 : (11 - rest);

        // Verifica que los dígitos verificadores coincidan
        return (digit1 === parseInt(cpf.charAt(9)) && digit2 === parseInt(cpf.charAt(10)));
      };

      if (!isValidCpf(formPix.cpf))
      return errorNotification("El CPF ingresado no es válido", "top-center");
    }

    if (!formPix.monto || !formPix.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formPix.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formPix,
      monto,
      id_uo,
      token
    };

    setLoading(true);
    const res = await axios.post(
      API_URL + "generarSolicitudRetiroPixOut",
      body
    );
    console.log(res);

    if (res.data.error === 0) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.error) {

        if(res.data.error.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.error.includes("en espera")) {
            let verificando = {
              title: `En espera.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroSpei = async (e) => {
    e.preventDefault();

    if (!formSpei.receiver_clabe || !formSpei.receiver_clabe.trim())
    return errorNotification(
      "Por favor ingrese Clave",
      "top-center"
    );

    if (!formSpei.monto || !formSpei.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formSpei.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formSpei,
      monto,
      id_uo,
      token
    };

    setLoading(true);
    const res = await axios.post(
      API_URL + "generarSolicitudRetiroSPEIOut",
      body
    );
    console.log(res);

    if (res.data.error === 0) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.error) {
        if(res.data.error.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.error.includes("en espera")) {
            let verificando = {
              title: `En espera.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroAlps = async (e) => {
    e.preventDefault();

    if (!formAlps.document_type || !formAlps.document_type.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );

    if (!formAlps.document || !formAlps.document.trim())
    return errorNotification(
      "Por favor ingrese documento de identidad",
      "top-center"
    );

    if (!formAlps.bank || !formAlps.bank.trim())
    return errorNotification(
      "Por favor selecciones el banco",
      "top-center"
    );
    if (!formAlps.bank_account_type || !formAlps.bank_account_type.trim())
    return errorNotification(
      "Por favor selecciones el tipo de cuenta",
      "top-center"
    );

    if (!formAlps.bank_account || !formAlps.bank_account.trim())
    return errorNotification(
      "Por favor ingrese numero de cuenta",
      "top-center"
    );
    let monto = parseFloat(
      formAlps.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    const [bankId, ...bankNameParts] = formAlps.bank.split(" - ");
    const bankName = bankNameParts.join(" - ");

    const body = {
      ...formAlps,
      id_uo,
      token,
      amount: monto,
      bank_id: bankId, 
      bank_name: bankName
    };

    setLoading(true);
    const res = await axios.post(API_URL + "createWithdrawalTransactionALPS", body);

    if (res.data.code === 200) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.message) {
         if(res.data.message.includes("mayor")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{

          if(res.data.message.includes("en espera")) {
            let verificando = {
              title: `En espera.`,
              text: `${res.data.message}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.message, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroKushkiRetiro = async (e) => {
    e.preventDefault();

    if (!formKushkiRetiro.account_number || !formKushkiRetiro.account_number.trim())
    return errorNotification(
      "Por favor ingrese numero de cuenta",
      "top-center"
    );

    if (!formKushkiRetiro.tipo_cuenta || !formKushkiRetiro.tipo_cuenta.trim())
    return errorNotification(
      "Por favor seleccione tipo de cuenta",
      "top-center"
    );

    if (!formKushkiRetiro.bank_id || !formKushkiRetiro.bank_id.trim())
    return errorNotification(
      "Por favor seleccione el banco",
      "top-center"
    );

    if (!formKushkiRetiro.monto || !formKushkiRetiro.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    if (formKushkiRetiro.bank_id === '002' && formKushkiRetiro.tipo_cuenta === 'CC' 
      && formKushkiRetiro.account_number.length !== 13) {
      return errorNotification(
        "El numero de cuenta debe contener 13 dígitos",
        "top-center"
      );
    }

    if (formKushkiRetiro.bank_id === '002' && formKushkiRetiro.tipo_cuenta === 'CA' 
      && formKushkiRetiro.account_number.length !== 14) {
      return errorNotification(
        "El numero de cuenta debe contener 14 dígitos",
        "top-center"
      );
    }

    if (formKushkiRetiro.bank_id !== '002' && formKushkiRetiro.account_number.length !== 20) {
      return errorNotification(
        "El numero de cuenta debe contener 20 dígitos",
        "top-center"
      );
    }

    if (formKushkiRetiro.tipodocumento === 'CE' && (formKushkiRetiro.document.length < 9 || formKushkiRetiro.document.length > 12)) {
      return errorNotification(
        "CE debe contener entre 9 y 12 dígitos",
        "top-center"
      );
    }

    if (formKushkiRetiro.tipodocumento === 'DNI' && formKushkiRetiro.document.length !== 8) {
      return errorNotification(
        "DNI debe contener 8 dígitos",
        "top-center"
      );
    }

    if (formKushkiRetiro.tipodocumento === 'PAS' && (formKushkiRetiro.document.length < 7 || formKushkiRetiro.document.length > 12)) {
      return errorNotification(
        "PAS debe contener entre 7 y 12 dígitos",
        "top-center"
      );
    }

    if (formKushkiRetiro.tipodocumento === 'RUC' && formKushkiRetiro.document.length !== 11) {
      return errorNotification(
        "RUC debe contener 11 dígitos",
        "top-center"
      );
    }


    let monto = parseFloat(
      formKushkiRetiro.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formKushkiRetiro,
      monto,
      id_uo,
      token
    };

    setLoading(true);
    const res = await axios.post(
      API_URL + "generarSolicitudRetiro",
      body
    );
    console.log(res);

    if (res.data.error === 0) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.error) {
        if(res.data.message.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.message.includes("en espera")) {
            let verificando = {
              title: `En espera.`,
              text: `${res.data.message}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.message, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroMibanco = async (e) => {
    e.preventDefault();
    if (!formMibanco.tipodocumento || !formMibanco.tipodocumento.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );
    if (!formMibanco.cedula || !formMibanco.cedula.trim())
    return errorNotification(
      "Por favor ingrese la cedula",
      "top-center"
    );

    if (formMibanco.cedula.length < 7 || formMibanco.cedula.length > 8)
    return errorNotification(
      "El documento de identidad debe contener 7 o 8 digitos",
      "top-center"
    );
  
    if (!formMibanco.banco || !formMibanco.banco.trim())
    return errorNotification(
      "Por favor seleccione el banco",
      "top-center"
    );
    if (!formMibanco.telefono_destino || !formMibanco.telefono_destino.trim())
    return errorNotification(
      "Por favor ingrese el telefono",
      "top-center"
    );

    if (!/^(0412|0416|0426|0414|0424)\d{7}$/.test(formMibanco.telefono_destino)) {
      return errorNotification(
        "El teléfono debe comenzar con: 0412, 0416, 0426, 0414 o 0424 y tener 11 dígitos en total",
        "top-center"
      );
    }


    if (!formMibanco.monto1 || !formMibanco.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a retirar",
      "top-center"
    );
    let monto = parseFloat(
      formMibanco.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    let partes = formMibanco.banco.split("-")
    let bank_code = partes[0];
    let bank_name = partes[1];
    const body = {
      ...formMibanco,
      amount: monto,
      bank_code,
      bank_name,
      id_uo,
      token
    };
    setLoading(true);
    const res = await axios.post(
      API_URL + "createWithdrawalTransactionMibanco",
      body
    );
    console.log(res.data);
    if (res.data.code === 200) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.code !== 200) {
        if(res.data.message.includes("es mayor")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.message.includes("pendiente")) {
            let verificando = {
              title: `Retiro Pendiente.`,
              text: `${res.data.message}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.message, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroTransPYG = async (e) => {
    e.preventDefault();

   if (!/^\d{6,8}$/.test(formTransPYG.document_number)) {
      return errorNotification(
        "El número de CI debe tener entre 6 y 8 dígitos numéricos." , 
        "top-center"
      );
    }

    if (!formTransPYG.document_number || !formTransPYG.document_number.trim())
    return errorNotification(
      "Por favor ingrese el documento de identidad",
      "top-center"
    );

    if (!formTransPYG.bank_code || !formTransPYG.bank_code.trim())
    return errorNotification(
      "Por favor seleccione el banco",
      "top-center"
    );

    if (!formTransPYG.account_number || !formTransPYG.account_number.trim())
    return errorNotification(
      "Por favor seleccione ingrese numero de cuenta",
      "top-center"
    );

    if (!formTransPYG.document_type|| !formTransPYG.document_type.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento de identidad",
      "top-center"
    );


    if (!formTransPYG.monto || !formTransPYG.monto.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formTransPYG.monto.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formTransPYG,
      monto,
      id_uo,
      token
    };

    setLoading(true);
    const res = await axios.post(
      API_URL + "createWithdrawalParaguayHPP",
      body
    );
    console.log(res);

    if (res.data.error === 0) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.error) {
        if(res.data.error.includes("suficiente")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.error.includes("en espera")) {
            let verificando = {
              title: `En espera.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };

  const solicitarRetiroBDV = async (e) => {
    e.preventDefault();
    if (!formBDV.document_type || !formBDV.document_type.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );
    if (!formBDV.cedula || !formBDV.cedula.trim())
    return errorNotification(
      "Por favor ingrese la cedula",
      "top-center"
    );

    if (formBDV.cedula.length < 6 || formBDV.cedula.length > 9)
    return errorNotification(
      "El documento de identidad debe contener entre 6 o 9 digitos",
      "top-center"
    );
  
    if (!formBDV.bank_code || !formBDV.bank_code.trim())
    return errorNotification(
      "Por favor seleccione el banco",
      "top-center"
    );
    if (!formBDV.destination_phone || !formBDV.destination_phone.trim())
    return errorNotification(
      "Por favor ingrese el telefono",
      "top-center"
    );

    if (!/^(0412|0416|0426|0414|0424)\d{7}$/.test(formBDV.destination_phone)) {
      return errorNotification(
        "El teléfono debe comenzar con: 0412, 0416, 0426, 0414 o 0424 y tener 11 dígitos en total",
        "top-center"
      );
    }


    if (!formBDV.monto1 || !formBDV.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a retirar",
      "top-center"
    );
    let monto = parseFloat(
      formBDV.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    const body = {
      ...formBDV,
      amount: monto,
      id_uo,
      token
    };
    setLoading(true);
    const res = await axios.post(
      API_URL + "createWithdrawalTransactionBDV",
      body
    );
    console.log(res.data);
    if (res.data.code === 200) {
      let verificando = {
        title: `Enviada satisfactoriamente.`,
        text: `Su solicitud de retiro ha sido enviada satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificando);
      handleClose();
    } else {
      if (res.data.code !== 200) {
        if(res.data.message.includes("es mayor")) {
          let verificando = {
            title: `Saldo insuficiente.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          if(res.data.message.includes("pendiente")) {
            let verificando = {
              title: `Retiro Pendiente.`,
              text: `${res.data.message}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificando);
            handleClose();
          }else{
            errorNotification(res.data.message, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  };


  return {
    loading,
    form,
    setForm,
    clearForm,
    formAstroPay,
    formPay4Fun,
    formPayRetailer,
    formTuPay,
    formMonnet,
    formMonnetperu,
    formPagoFacil,
    formCoinspaidRetiro,
    formBinanceUSD,
    formPix,
    formSpei,
    formAlps,
    formKushkiRetiro,
    formMibanco,
    formTransPYG,
    formBDV,
    bancoTipo,
    handleChangePay4Fun,
    handleBanco,
    handleChangePayRetailer,
    handleChangeTuPay,
    handleChangeMonnet,
    handleChangeMonnetperu,
    handleChangePagoFacil,
    handleChangeCoinspaidRetiro,
    handleChangeBinanceUSD,
    handleChangePix,
    handleChangeSpei,
    handleChangeAlps,
    handleChangeKushkiRetiro,
    handleChangeMibanco,
    handleChangeTransPYG,
    handleChangeBDV,
    solicitarRetiro,
    solicitarRetiroRetailer,
    solicitarRetiroAstroPay,
    solicitarRetiroPayRetailer,
    solicitarRetiroTuPay,
    solicitarRetiroMonnet,
    solicitarRetiroMonnetperu,
    solicitarRetiroPagoFacil,
    solicitarRetiroCoinspaid,
    solicitarRetiroBinanceUSD,
    solicitarRetiroPix,
    solicitarRetiroSpei,
    solicitarRetiroAlps,
    solicitarRetiroKushkiRetiro,
    solicitarRetiroMibanco,
    solicitarRetiroTransPYG,
    solicitarRetiroBDV,
    handleChange,
    handleChangeAstroPay,
  };
};
